export default __webpack_public_path__ + "static/vitamin-d-inflammation-box@2x-40f2ffb4bdf5199fff3893a51ff3e833.png";